import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {EditAccountModel, FinancialChartAccount} from '../../../_models/financial-account.model';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MessageService, PrimeNGConfig} from 'primeng/api';
import {FinancialChartService} from '../../../_services/financial-chart.service';

@Component({
    selector: 'acabim-admin-edit-account',
    templateUrl: './edit-account.component.html',
    styleUrls: ['./edit-account.component.scss'],
    providers: [MessageService]

})
export class EditAccountComponent implements OnInit {
    editAccountForm: any;
    isLoading = false;
    valueTypes: { name: string }[] = [];
    accountTypes: { name: string }[] = [];
    @Input() classes: any[] = [];

    @Input() accountDetail?: FinancialChartAccount;
    @Input() classId?: number;

    @Output() closeModal = new EventEmitter<string>();

    // tslint:disable-next-line:use-lifecycle-interface
    ngOnChanges(changes: SimpleChanges): void {
        if (changes.accountDetail) {
            this.isLoading = true;
            this.financialService.getValueTypes().subscribe(data => {
                this.valueTypes = [];
                data.forEach(str => {
                    this.valueTypes.push({name: str});
                });
                this.financialService.getAccountTypes().subscribe((accounts => {
                    this.isLoading = false;
                    this.accountTypes = [];
                    accounts.forEach(str => {
                        this.accountTypes.push({name: str});
                    });
                    console.dir(accounts);
                    if (this.accountDetail) {
                        this.editAccountForm.get('identifier').setValue(this.accountDetail.identifier);
                        this.editAccountForm.get('name').setValue(this.accountDetail.name);
                        this.editAccountForm.get('description').setValue(this.accountDetail.description);
                        const accountType = this.accountTypes.filter(x => x.name === this.accountDetail?.account_type)[0];
                        this.editAccountForm.get('accountType').setValue(accountType);
                        const valueType = this.valueTypes.filter(x => x.name === this.accountDetail?.value_type)[0];
                        this.editAccountForm.get('valueType').setValue(valueType);
                        this.editAccountForm.get('status').setValue(this.accountDetail.status === 'active');
                        const accountClass = this.classes.filter(x => x.id === this.classId)[0];
                        this.editAccountForm.get('class').setValue(accountClass);

                    }
                }), error => {
                    this.isLoading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Cannot get account types'
                    });
                });
            }, error => {
                this.isLoading = false;
                this.messageService.clear();
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Cannot get value types'
                });
            });

        }
    }

    constructor(private messageService: MessageService,
                private primengConfig: PrimeNGConfig,
                private readonly financialService: FinancialChartService) {
        this.editAccountForm = new FormGroup({
                identifier: new FormControl(null, Validators.required),
                name: new FormControl(null, Validators.required),
                description: new FormControl(null),
                class: new FormControl(null, Validators.required),
                accountType: new FormControl(null),
                valueType: new FormControl(null),
                status: new FormControl(false)
            }
        );
    }

    ngOnInit(): void {
        this.primengConfig.ripple = true;

    }

    onSubmit() {
        if (this.editAccountForm.valid) {
            this.isLoading = true;
            const body: EditAccountModel = {
                account_type: this.editAccountForm.get('accountType').value?.name,
                description: this.editAccountForm.get('description').value,
                identifier: this.editAccountForm.get('identifier').value,
                name: this.editAccountForm.get('name').value,
                value_type: this.editAccountForm.get('valueType').value?.name
            };
            if (this.accountDetail) {
                // tslint:disable-next-line:no-non-null-assertion
                this.financialService.updateAccount(this.editAccountForm.get('class').value.id, body, this.accountDetail!.id).subscribe(data => {
                    // @ts-ignore
                    if ((this.accountDetail.status === 'active') !== this.editAccountForm.get('status').value) {
                        this.financialService.toggleAccountStatus(this.editAccountForm.get('class').value.id, this.accountDetail?.id).subscribe(() => {
                            this.isLoading = false;
                            this.closeModal.emit('account ' + this.accountDetail?.full_identifier + ':  details and status has been updated');
                        }, error => {
                            this.isLoading = false;
                            this.messageService.clear();
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Error',
                                detail: 'Account details updated, cannot update account status'
                            });
                        });
                    } else {
                        this.isLoading = false;
                        this.closeModal.emit('account ' + this.accountDetail?.full_identifier + ':  details has been updated');
                    }
                }, error => {
                    this.isLoading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Cannot update account, please contact administrator'
                    });
                });
            } else {
                this.financialService.addNewAccount(this.editAccountForm.get('class').value.id, body).subscribe(data => {
                    this.isLoading = false;
                    this.closeModal.emit('account has been created');
                }, error => {
                    this.isLoading = false;
                    this.messageService.clear();
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Cannot add account, please contact administrator'
                    });
                });
            }
        } else {
            this.messageService.clear();
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Please fill all required fields'
            });
        }
    }
}
